import request from '@/utils/http';

// 可教科目
export function getSubjects() {
  return request({
    url: '/teacher/subjects',
    method: 'get'
  })
}

// 年级列表
export function getGradeList() {
  return request({
    url: '/order/grade_list',
    method: 'get'
  })
}

// 订单列表
export function getOrderList(org, params = {}) {
  return request({
    url: `/order/list/org/${org}`,
    method: 'get',
    params
  })
}

// 老师提交简历
export function submitResume(data) {
  return request({
    url: '/teacher/submit',
    method: 'post',
    data: new URLSearchParams(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 获取微信授权地址
export function GetOauthUrl(redirectUrl) {
  return request({
    url: '/wx/get_oauth_url',
    method: 'post',
    params: {
      redirect_url: redirectUrl
    }
  })
}

// 获取微信openid
export function GetWxUserFromCode(code) {
  return request({
    url: '/wx/get_wx_user_from_code',
    method: 'post',
    params: {
      code: code
    }
  })
}